module.exports = __webpack_public_path__ + "assets/c34b23d78bf9126cf9c7fdab0158d939.mp4";